import React from 'react';
import { DatePicker } from 'modules/common/components/form/DatePicker';
import { DATE_TIME_FORMAT, ICON_BUTTON_SIZE } from 'modules/common/constants';
import moment from 'moment';
import { formatDate } from 'modules/common/services/formatting/date';
import { ICellRendererParams } from 'ag-grid-community';
import styles from './PaymentList.module.scss';
import { Icon } from '@blueprintjs/core';
import { FlowDatasetOrderPaymentSnapshotType } from 'modules/main/models/orders-chart';

const convert = (value: string) => {
    const temp = moment(value, DATE_TIME_FORMAT);
    return temp.isValid() ? temp.toDate() : value;
};

import { GlobalEscape } from "modules/common/components/hotkeys/GlobalEscape";

const format = (value: Date | string) => value instanceof Date ? formatDate(value) : value;

export class DateCell extends React.PureComponent<ICellRendererParams, { value: any, active: boolean }> {
    constructor (props: ICellRendererParams) {
        super(props);
        this.state = { value: convert(props.value), active: false };
    }

    componentDidUpdate (prevProps: ICellRendererParams) {
        if (this.props.value !== prevProps.value) {
            this.setState({ value: convert(this.props.value) });
        }
    }

    render () {
        const { value, active } = this.state;

        return (
            <div className={styles.date}>
                {active && <GlobalEscape onEscape={this.cancel} />}
                {!active && (
                    <div className={styles.value}>{format(value)}</div>
                )}
                {active && (
                    <DatePicker
                        rootBoundary="viewport"
                        value={value}
                        onChange={this.onChange}
                    />
                )}
                {active && (
                    <Icon icon='floppy-disk' className={styles.button} onClick={this.save} size={ICON_BUTTON_SIZE} />
                )}
                {!active && (
                    <Icon icon='edit' className={styles.button} onClick={this.activate} size={ICON_BUTTON_SIZE} />
                )}
            </div>
        );
    }

    activate = () => this.setState({ active: true });

    cancel = () => this.setState({ active: false, value: convert(this.props.value) });

    save = async () => {
        const { value } = this.state;
        const { context, data } = this.props;
        if (!value) {
            return;
        }

        const success = await (context as DateCellContext).setPaymentDate(getRowNodeId(data), value);
        success && this.setState({ active: false });
    }

    onChange = (value: Date | null) => value && this.setState({ value });
}

export const getRowNodeId = (node: FlowDatasetOrderPaymentSnapshotType) => node.guid;

export interface DateCellContext {
    setPaymentDate: (guid: string, date: Date) => Promise<boolean>;
}
